export const matchesCarrierSearch = (
  carrier: { name: string; scac: string },
  term: string,
): boolean => {
  if (!term) return true
  const needle = term.toLowerCase()
  return (
    carrier.name.toLowerCase().includes(needle) ||
    carrier.scac.toLowerCase().includes(needle)
  )
}
